<template>
  <div>
    <div class="d-flex align-end pb-4">
      <v-icon class="mr-2">{{ icon.search }}</v-icon>
      <v-text-field
        v-model="search"
        :label="$t('table.search')"
        single-line
        hide-details
        clearable
      >
      </v-text-field>
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            class="ml-2"
            @click="downloadTable"
            :loading="downloading"
            :disabled="downloading"
          >
            <v-icon>{{ icon.download }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("table.downloadTable") }}</span>
      </v-tooltip>
    </div>
    <div class="rank-table">
      <v-data-table
        :headers="headers"
        :items="rows"
        item-key="key"
        :search="search"
        :locale="this.$i18n.locale"
        sort-by="_all"
        must-sort
        dense
        :custom-sort="customSort"
        :header-props="{
          sortIcon: 'mdi-arrow-down'
        }"
      >
        <template v-slot:item.key="{ item }">
          <span v-html="mark(item.key)"></span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mdiFileDownloadOutline, mdiMagnify } from "@mdi/js";
import { unparse } from "papaparse";
import createSearch from "@/utils/create-search";
export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    search: "",
    icon: {
      search: mdiMagnify,
      download: mdiFileDownloadOutline
    },
    downloading: false
  }),
  computed: {
    searchRegexArr() {
      return createSearch(this.search);
    }
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (isDesc != "false") {
          return a[index] < b[index] ? -1 : 1;
        } else {
          return b[index] < a[index] ? -1 : 1;
        }
      });
      return items;
    },
    mark(text) {
      let wrapped = String(text);
      if (this.search) {
        this.searchRegexArr.forEach(re => {
          if (wrapped.search(re) !== -1) {
            wrapped = wrapped.replace(re, "<span class='mark'>$&</span>");
          }
        });
        return wrapped;
      } else {
        return wrapped;
      }
    },
    downloadTable() {
      this.downloading = true;
      const fileName = `${this.headers[0].text.toLowerCase()}.csv`;
      const csv = unparse(
        this.rows.map(d =>
          this.headers.reduce((e, header) => {
            e[header.text] = d[header.value];
            return e;
          }, {})
        )
      );
      // https://stackoverflow.com/a/24922761
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      setTimeout(() => {
        this.downloading = false;
      }, 500);
    }
  }
};
</script>

<style scoped>
>>> .mark {
  background: orange;
}
</style>
